import rimg from '@pixelunion/rimg-shopify'; // eslint-disable-line
import AsyncView from '@pixelunion/shopify-asyncview';

import ProductMasonry from '../components/ProductMasonry';

export default class StaticProductRecommendations {
  constructor(section) {
    this.data = section.data;

    this._init();

    this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=static-product-recommendations&product_id=${this.productId}`;

    this._reloadRecommendations = this._reloadRecommendations.bind(this);
    window.addEventListener('shopify:section:load', this._reloadRecommendations);

    this._loadRecommendations();
  }

  _init() {
    this.productId = this.data.productId;
    this.position = this.data.position;

    const productSectionData = JSON.parse(document.querySelector('[data-section-type="product"]').innerHTML);
    this.use_masonry = productSectionData.images_layout === 'masonry';

    if (this.use_masonry) {
      this.position = 'below';
    }

    this.productEl = document.querySelector('.product');
    this.productEl.classList.add(`product-recommendations-position-${this.position}`);

    this.recommendationContainer = document.querySelector('[data-product-recommendations]');
    this.recommendationContainer.innerHTML = '';
  }

  _loadRecommendations() {
    AsyncView.load(
      this.recommendUrl,
      { view: '' },
    ).then(({ html }) => {
      if (!html.common) {
        return;
      }
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = html.common;
      const productsWrapper = tempContainer.querySelector('.product-recommendations');

      if (this.position === 'below' || this.use_masonry) {
        productsWrapper.innerHTML = html.below;
      } else {
        productsWrapper.innerHTML = html.right;
      }

      if (this.use_masonry) {
        productsWrapper.classList.remove('row-of-4');
        productsWrapper.classList.add('row-of-3');
      } else {
        // Remove extra products for non-masonry layouts
        productsWrapper
          .querySelectorAll('[data-masonry-only]')
          .forEach(product => product.parentNode.removeChild(product));
      }

      this.recommendationContainer.innerHTML = tempContainer.innerHTML;

      if (this.use_masonry) {
        this.productMasonry = new ProductMasonry({ el: this.recommendationContainer });
      }

      rimg.watch(this.recommendationContainer);

      const productItems = this.recommendationContainer.querySelectorAll('.product-list-item');

      if (productItems.length) {
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
    });
  }

  // This method is only called inside of the theme editor
  // when the user changes product section settings
  _reloadRecommendations() {
    this._init();
    this._loadRecommendations();
  }

  onSectionUnload() {
    if (this.productMasonry) {
      this.productMasonry.onSectionUnload();
    }

    this.productEl.classList.remove(`product-recommendations-position-${this.position}`);
    this.recommendationContainer.innerHTML = '';
    window.removeEventListener('shopify:section:load', this._reloadRecommendations);
  }
}
